<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { usePolicy } from 'dashboard/composables/usePolicy';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import SamlSettings from '../../security/components/SamlSettings.vue';
import SamlPaywall from '../../security/components/SamlPaywall.vue';
import SectionLayout from '../../account/components/SectionLayout.vue';

const { t } = useI18n();
const { shouldShow, shouldShowPaywall } = usePolicy();

const allowedLoginMethods = computed(
  () => window.chatwootConfig.allowedLoginMethods || ['email']
);

const isSamlSsoEnabled = computed(() =>
  allowedLoginMethods.value.includes('saml')
);

const shouldShowSaml = computed(() => {
  const hasPermission = shouldShow(
    FEATURE_FLAGS.SAML,
    ['administrator'],
    [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE]
  );
  return hasPermission && isSamlSsoEnabled.value;
});

const showPaywall = computed(() => shouldShowPaywall('saml'));
</script>

<template>
  <SectionLayout
    :title="t('SECURITY_SETTINGS.TITLE')"
    :description="t('SECURITY_SETTINGS.DESCRIPTION')"
    with-border
  >
    <SamlPaywall v-if="showPaywall" />
    <SamlSettings v-else-if="shouldShowSaml" full-width />
    <div v-else class="text-sm text-n-slate-11">
      {{ t('SECURITY_SETTINGS.SAML_DISABLED_MESSAGE') }}
    </div>
  </SectionLayout>
</template>
